import { type IMediaInstance } from "@pixi/sound"

/** One owned loop, including playback requests still waiting for audio decoding. */
export class BonecallerChant {
    private track?: { key: string; player?: IMediaInstance; volume: number }
    private lastAt = 0
    private retryAt = 0

    constructor(private play: () => IMediaInstance | Promise<IMediaInstance>) {}

    stop = () => {
        const track = this.track
        this.track = undefined
        track?.player?.stop()
    }

    update = (key: string | undefined, volume: number, now: number) => {
        const elapsed = Math.min(100, Math.max(0, now - this.lastAt))
        this.lastAt = now
        if (!key) { this.stop(); return }
        if (this.track && this.track.key !== key) this.stop()
        if (!this.track && volume > 0 && now >= this.retryAt) {
            const track = { key, volume: 0, player: undefined as IMediaInstance | undefined }
            this.track = track
            // A stopped/replaced request must never start sounding when decoding finishes.
            Promise.resolve().then(() => this.track === track ? this.play() : undefined).then(player => {
                if (!player) return
                if (this.track !== track) { player.stop(); return }
                track.player = player
                player.set("volume", track.volume)
            }).catch(() => {
                if (this.track === track) { this.track = undefined; this.retryAt = now + 1000 }
            })
        }
        const track = this.track
        if (!track) return
        if (!track.player && volume === 0) { this.stop(); return }
        track.volume += (volume - track.volume) * (1 - Math.exp(-elapsed / 200))
        track.player?.set("volume", track.volume)
        if (volume === 0 && track.volume < 0.001) this.stop()
    }
}
